import React from 'react';
import { ShieldIcon, FileTextIcon, ZapIcon, LockIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-6 sm:py-10 lg:py-16 px-4 sm:px-6 lg:px-8" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-81">
          {/* Left Column: Text */}
          <div className="text-left flex flex-col" data-id="element-82">
            {/* Main Headline */}
            <h1 className="order-2 text-3xl sm:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 leading-tight text-[#1A1A1A]" data-id="element-83">
              Kit de Supervivencia Fiscal Argentina
            </h1>

            {/* Subheadline */}
            <p className="order-3 text-base sm:text-xl text-[#6B7280] mb-5" data-id="element-84">
              Todo lo que necesitás para proteger tu plata. Listo. Desde hoy.
            </p>

            {/* CTA Button — mobile: shows right after subheadline / desktop: after badges */}
            <div className="order-4 lg:order-8 mb-6 lg:mb-0" data-id="element-85">
              <button onClick={scrollToPricing} className="inline-flex items-center justify-center w-full sm:w-auto gap-2 px-8 py-4 bg-[#5BB4A0] hover:bg-[#4A9382] text-white text-lg font-bold rounded-lg transition-colors shadow-md mb-3" data-id="element-86">
                <ShieldIcon className="w-5 h-5" data-id="element-87" />→ QUIERO MI KIT AHORA
              </button>

              {/* Trust line */}
              <p className="text-sm text-[#6B7280]" data-id="element-88">
                🔒 Pago seguro | 💳 Mercado Pago
              </p>
            </div>

            {/* Divider */}
            <div className="order-5 lg:order-4 w-24 h-1 bg-[#5BB4A0] mb-5" data-id="element-89"></div>

            {/* Secondary headline */}
            <p className="order-6 lg:order-5 text-base sm:text-lg font-semibold text-[#1A1A1A] mb-3" data-id="element-90">
              El sistema N°1 para Monotributistas y Trabajadores Independientes
              en Argentina
            </p>

            {/* Product line */}
            <p className="order-7 lg:order-6 text-sm sm:text-base text-[#6B7280] mb-5" data-id="element-91">
              3 Tomos + 1 Bonus + Manual del Reintegro — 100% PDF — Acceso en 5
              minutos
            </p>

            {/* Badge row */}
            <div className="order-8 lg:order-7 flex flex-wrap items-center gap-2 mb-6 lg:mb-6" data-id="element-92">
              <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-[#EAE5DC] shadow-sm" data-id="element-93">
                <FileTextIcon className="w-4 h-4 text-[#5BB4A0]" data-id="element-94" />
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-95">
                  100% PDF
                </span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-[#EAE5DC] shadow-sm" data-id="element-96">
                <ZapIcon className="w-4 h-4 text-[#5BB4A0]" data-id="element-97" />
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-98">
                  Acceso en 5 min
                </span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-[#EAE5DC] shadow-sm" data-id="element-99">
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-100">
                  🇦🇷 Edición 2026
                </span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-[#EAE5DC] shadow-sm" data-id="element-101">
                <LockIcon className="w-4 h-4 text-[#5BB4A0]" data-id="element-102" />
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-103">
                  Pago Seguro
                </span>
              </div>
            </div>
          </div>

          {/* Right Column: Product Image */}
          <div className="relative order-first lg:order-last mb-2 lg:mb-0 flex justify-center" data-id="element-104">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-[#EAE5DC] bg-white max-w-[240px] sm:max-w-sm lg:max-w-xl lg:max-h-[640px]" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/kXYNp1hrr5ooD4CEkKesrq/KIT_IMAGEN_FINAL.png" alt="Kit de Supervivencia Fiscal Argentina - 3 Tomos y Bonus" className="w-full h-full object-contain" data-id="element-106" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}